const PROFILE_URLS = {
  AddBalanceIcon: 'https://static.zone.game/images/profile/AddBalanceIcon.svg',
  SendBalanceIcon:
    'https://static.zone.game/images/profile/SendBalanceIcon.svg',
  RedUpArrow: 'https://static.zone.game/images/profile/RedUpArrow.svg',
  GreenDownArrow: 'https://static.zone.game/images/profile/GreenDownArrow.svg',
  TransactionsIcon:
    'https://static.zone.game/images/profile/TransactionsIcon.svg',
  WalletIcon: 'https://static.zone.game/images/profile/walletIcon.svg',
  ReferralCash: 'https://static.zone.game/images/profile/ReferralCash.svg',
  ReferralDonation:
    'https://static.zone.game/images/profile/ReferralDonation.svg',
  ReferralFriends:
    'https://static.zone.game/images/profile/ReferralFriends.svg',
  ReferralLevel: 'https://static.zone.game/images/profile/referralLevel.svg',
  ReferralMoney: 'https://static.zone.game/images/profile/ReferralMoney.svg',
  Level: 'https://static.zone.game/images/profile/level.svg',
  ReferLevel: 'https://static.zone.game/images/profile/ReferLevel.svg',
  ReferralMoneySack:
    'https://static.zone.game/images/profile/ReferralMoneySack.svg',
  NoReferralImg: 'https://static.zone.game/images/profile/NoReferralImg.svg',
  GiftBox: 'https://static.zone.game/images/profile/giftBox.svg',
};

export default PROFILE_URLS;
